/**
 * Természetes (natural) rendezési segédfüggvények adattáblázatokhoz.
 * Biztosítja, hogy az "1. pont", "2. pont" ... "9. pont", "10. pont"
 * sorrend helyesen, számszaki sorrendben jelenjen meg.
 */

export function naturalCompare(a: any, b: any): number {
  if (a === null || a === undefined) return b === null || b === undefined ? 0 : -1;
  if (b === null || b === undefined) return 1;

  let strA = String(a).trim();
  let strB = String(b).trim();

  // OCR typo és római I. javítás: 'l.' -> '1.', 'I.' -> '1.'
  strA = strA.replace(/^l\./i, '1.').replace(/^I\./, '1.');
  strB = strB.replace(/^l\./i, '1.').replace(/^I\./, '1.');

  // Magyar lokál alapú összehasonlítás numeric: true beállítással
  return strA.localeCompare(strB, 'hu', { numeric: true, sensitivity: 'base' });
}

export type SortDirection = 'asc' | 'desc';

export interface SortState {
  column: string;
  direction: SortDirection;
}

export function sortData<T>(
  data: T[],
  column: string,
  direction: SortDirection,
  getValue?: (item: T, column: string) => any
): T[] {
  return [...data].sort((a, b) => {
    const valA = getValue ? getValue(a, column) : (a as any)[column];
    const valB = getValue ? getValue(b, column) : (b as any)[column];

    const result = naturalCompare(valA, valB);
    return direction === 'asc' ? result : -result;
  });
}
